import { ButtonSound } from '@jollywise/jollygoodgame';
import { ButtonComposited } from '../display/ui/ButtonComposited';
import { ButtonExtended } from '../input/ButtonExtended';

export const HudConfig = {
  defaultButton: ButtonExtended,
  icons: [],
  modal: { colour: '0x000000', alpha: 0.8 },
  onboarding: {},
  howtoplay: [
    {
      image_key: 'ftb_img',
      copy_title: 'FeedTheBirds_name',
      copy_instruction: 'FeedTheBirds_instruction',
    },
    {
      image_key: 'kotc_img',
      copy_title: 'KeepOutTheCold_name',
      copy_instruction: 'KeepOutTheCold_instruction',
    },
    {
      image_key: 'bk_img',
      copy_title: 'BeeKind_name',
      copy_instruction: 'BeeKind_instruction',
    },
    {
      image_key: 'esb_img',
      copy_title: 'EndlessSoapBar_name',
      copy_instruction: 'EndlessSoapBar_instruction',
    },
    {
      image_key: 'ff_img',
      copy_title: 'FriendlyFlora_name',
      copy_instruction: 'FriendlyFlora_instruction',
    },
    {
      image_key: 'ws_img',
      copy_title: 'WaterSaviour_name',
      copy_instruction: 'WaterSaviour_instruction',
    },
    {
      image_key: 'es_img',
      copy_title: 'EnergySaver_name',
      copy_instruction: 'EnergySaver_instruction',
    },
    {
      image_key: 'ee_img',
      copy_title: 'EcoExpert_name',
      copy_instruction: 'EcoExpert_instruction',
    },
  ],
  buttons: [
    {
      id: 'btn_home',
      costume: 'btn_home',
      buttongroup: 'topleft',
      ariaLabel: 'home',
      // vo: { sheet: 'gelvo', id: 'home' },
      event: 'RETURN_HOME',
    },
    {
      id: 'btn_howtoplay',
      buttongroup: 'bottomright',
      ariaLabel: 'howtoplay',
      event: 'SHOW_INSTRUCTIONS',
      buttonClass: ButtonComposited,
      copyid: 'title_how_to_play',
      buttonType: 'primary',
      colour: '#ff007f',
    },
    {
      id: 'btn_back',
      costume: 'btn_back',
      buttongroup: 'topleft',
      ariaLabel: 'back',
      // vo: { sheet: 'gelvo', id: 'back' },
      event: 'BACK',
    },
    {
      id: 'btn_game_back',
      costume: 'btn_back',
      buttongroup: 'topleft',
      ariaLabel: 'back',
      // vo: { sheet: 'gelvo', id: 'back' },
      event: 'GAME_BACK',
    },
    {
      id: 'btn_pause',
      costume: 'btn_pause',
      buttongroup: 'topright',
      ariaLabel: 'pause',
      // vo: { sheet: 'gelvo', id: 'pause' },
      event: 'PAUSE_GAME',
    },
    {
      id: 'btn_howtoplay',
      costume: 'btn_howtoplay',
      buttongroup: 'bottomright',
      ariaLabel: 'how to play',
      // vo: { sheet: 'gelvo', id: 'howtoplay' },
      event: 'SHOW_INSTRUCTIONS',
      buttonClass: ButtonComposited,
      copyid: 'title_how_to_play',
      buttonType: 'secondary',
    },
    {
      id: 'btn_close',
      costume: 'btn_back',
      buttongroup: 'topleft',
      ariaLabel: 'back',
      // vo: { sheet: 'gelvo', id: 'back' },
      event: 'CLOSE_OVERLAY',
    },
    {
      id: 'btn_continueoverlay',
      costume: 'btn_continue',
      buttongroup: 'bottom',
      ariaLabel: 'continue',
      // vo: { sheet: 'gelvo', id: 'continue' },
      event: 'CLOSE_OVERLAY',
    },
    {
      id: 'btn_closeinstructions',
      costume: 'btn_back',
      buttongroup: 'topleft',
      ariaLabel: 'back',
      // vo: { sheet: 'gelvo', id: 'back' },
      event: 'CLOSE_INSTRUCTIONS',
    },
    {
      id: 'btn_sound',
      costume: 'btn_sound',
      buttongroup: 'topright',
      ariaLabel: 'toggle sound',
      event: 'TOGGLE_SOUND',
      // vo: { sheet: 'gelvo', id: 'turn_sound_off' },
      // resizeHitareaOnly: true,
      buttonClass: ButtonSound,
    },
    {
      id: 'btn_resume',
      costume: 'btn_play',
      buttongroup: 'center',
      ariaLabel: 'resume',
      // vo: { sheet: 'gelvo', id: 'resume' },
      event: 'RESUME_GAME',
    },
    {
      id: 'btn_play',
      costume: 'btn_play',
      buttongroup: 'welcome',
      ariaLabel: 'start game',
      // vo: { sheet: 'gelvo', id: 'play' },
      event: 'START_GAME',
    },
    {
      id: 'btn_skip',
      costume: 'btn_skip',
      buttongroup: 'bottomright',
      ariaLabel: 'skip',
      // vo: { sheet: 'gelvo', id: 'skip' },
      event: 'SKIP_CUTSCENE',
    },
    {
      id: 'btn_htp_next',
      costume: 'btn_forward',
      buttongroup: 'howtoplay_cycle',
      ariaLabel: 'next',
      clickSFX: { sprite: 'general', id: 'general_whoosh' },
    },
    {
      id: 'btn_htp_prev',
      costume: 'btn_back',
      buttongroup: 'howtoplay_cycle',
      ariaLabel: 'prev',
      clickSFX: { sprite: 'general', id: 'general_whoosh' },
    },
    {
      id: 'btn_closeinstructions',
      costume: 'btn_back',
      buttongroup: 'topleft',
      ariaLabel: 'back',
      event: 'CLOSE_INSTRUCTIONS',
    },
  ],
  states: {
    EMPTY: {
      buttons: [],
    },
    BASIC: {
      buttons: ['btn_pause'],
    },
    BASIC_HOME: {
      buttons: ['btn_home', 'btn_pause'],
    },
    BASIC_BACK: {
      buttons: ['btn_back', 'btn_pause'],
    },
    GAME: {
      buttons: ['btn_game_back', 'btn_pause'],
    },
    GAME_TIPS: {
      buttons: ['btn_close'],
    },
    GAME_END: {
      buttons: ['btn_pause', 'hud_bpp'],
    },
    WELCOME: {
      buttons: ['btn_sound', 'btn_play', 'btn_howtoplay'],
    },
    COMPLETE: {
      buttons: ['btn_home', 'btn_pause'],
    },
    PAUSE: {
      modal: true,
      buttons: ['btn_home', 'btn_sound', 'btn_resume'],
    },
    HOW_TO_PLAY: {
      buttons: ['btn_closeinstructions', 'btn_sound', 'btn_htp_prev', 'btn_htp_next'],
    },
    ONBOARDING: {
      buttons: ['btn_home', 'btn_pause', 'btn_skip_onboarding'],
    },
  },
  buttongroups: {
    welcome: {
      anchor_group: { x: 0.5, y: 0.5 },
      anchor_screen: { x: 0.5, y: 0.73 },
      align_buttons: 'center',
    },
    top: {
      anchor_group: { x: 0.5, y: 0 },
      anchor_screen: { x: 0.5, y: 0 },
      align_buttons: 'center',
    },
    howtoplay_cycle: {
      anchor_group: { x: 0.5, y: 0.5 },
      anchor_screen: { x: 0.5, y: 0.5 },
      align_buttons: 'center',
      buttonPadding: 790,
    },
  },
};
